export const INITIAL_FORM = {
    fileData: {
        name: "",
        size: 0,
        base64: ""
    }
};
export const INITIAL_ERRORS = {
    fileData: false
};
export const STEP_DESCRIPTIONS = [
    "Detalles del refuerzo",
    "Vista previa y confirmación"
];